import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import {
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { BaseComponent } from "src/app/shared/components/base/base.component";
import { SnackbarService } from "src/app/shared/components/snackbar/service/snackbar.service";
import { I18nService } from "src/app/shared/i18n/service/i18n.service";
import { SubSink } from "subsink";
import { ChangePasswordAndMailResponse } from "../../model/profile.model";
import { ProfileService } from "../../service/profile.service";
import { HeadingWidgetComponent } from "src/app/shared/components/heading-widget/heading-widget.component";
import { MaterialModule } from "src/app/shared/module/material.module";
import { I18nPipe } from "src/app/shared/i18n/pipe/i18n.pipe";
import { CommonModule } from "@angular/common";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: "ald-change-email",
    templateUrl: "./change-email.component.html",
    styleUrls: ["./change-email.component.scss"],
    imports: [
        HeadingWidgetComponent,
        MaterialModule,
        I18nPipe,
        CommonModule,
        ReactiveFormsModule,
    ]
})
export class ChangeEmailComponent
  extends BaseComponent
  implements OnInit, OnDestroy {
  private subs = new SubSink();
  changeMailForm: UntypedFormGroup;
  emailToChangeRequest: string;
  constructor(
    public dialogRef: MatDialogRef<ChangeEmailComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private formBuilder: UntypedFormBuilder,
    private i18n: I18nService,
    private profileService: ProfileService,
    private snack: SnackbarService
  ) {
    super();
    this.dialogRef.disableClose = true;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  translate(label): string {
    return this.i18n.getTranslation(label);
  }

  ngOnInit() {
    this.loadForm();
    this.newMailValueChange();
  }

  close() {
    this.dialogRef.close();
  }

  getErrorMessage(label) {
    const errorMessageToShow =
      this.control(this.changeMailForm, label).value.length === 0
        ? this.i18n.getTranslation("mandatory_field")
        : this.i18n.getTranslation("email_error");
    return this.capitalizeFirstLetter(
      `${errorMessageToShow} , ${this.getAliasTransaletAndCapitalizedFirstLetter(
        label
      )}`
    );
  }

  getAliasTransaletAndCapitalizedFirstLetter(alias) {
    return this.capitalizeFirstLetter(this.i18n.getTranslation(alias));
  }

  newMailValueChange() {
    this.valueChanges(this.changeMailForm, "newEmail").subscribe(
      (newMailValueChanged) => {
        this.emailToChangeRequest = newMailValueChanged;
      }
    );
  }

  loadForm() {
    this.changeMailForm = this.formBuilder.group({
      oldEmail: [],
      newEmail: new UntypedFormControl("", [
        Validators.required,
        Validators.pattern(
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ),
      ]),
    });
    const oldMail = sessionStorage.getItem("email");
    if (!!oldMail) {
      this.control(this.changeMailForm, "oldEmail").setValue(oldMail);
    } else {
      this.control(this.changeMailForm, "oldEmail").setValue(this.data);
    }

    this.control(this.changeMailForm, "oldEmail").disable();
  }

  openSnack(message: string, type: string) {
    const snackData: any = {};
    snackData.message = message;
    snackData.type = type;
    this.snack.openSnackBar(snackData);
  }

  submit() {
    this.subs.add(
      this.profileService
        .changeMail({ email: this.emailToChangeRequest })
        .subscribe((emailChanged: ChangePasswordAndMailResponse) => {
          sessionStorage.setItem("email", this.emailToChangeRequest);
          const message = "Modifiche avvenute correttamente, troverai la visualizzazione dei dati aggiornati al prossimo accesso.";
           // emailChanged.message +
           // "troverai la mail aggiornata al prossimo accesso";
          this.openSnack(message, "rfc-success");
          this.dialogRef.close();
        })
    );
  }
}
